import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  customDateContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },

  customDateField: {
    flex: 1,
    '& .MuiInputBase-root': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiInputBase-input': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      fontSize: '0.875rem',
    },
  },

  calendarIcon: {
    fontSize: '1rem',
    marginRight: theme.spacing(1),
  },

  expandIcon: {
    color: theme.new.color.text.secondary,
    fontSize: '1rem',
    marginLeft: theme.spacing(1),
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },

  datePickerPopper: {
    '& .MuiPickersLayout-root': {
      display: 'block',
    },
    '& .MuiPaper-root': {
      borderRadius: theme.new.shape.borderRadius.small,
      border: `1px solid ${theme.bdColors.smokyGrey}`,
    },
    '& .MuiPickersCalendarHeader-labelContainer': {
      ...theme.typography.small_body_medium,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.3rem',
    },
    '& .MuiPickersDay-root': {
      borderRadius: '0.25rem',
    },
    '& .MuiDayPicker-weekDayLabel': {
      ...theme.typography.small_body_regular,
    },
  },
}));

export default useStyles;
